export function ArrayRange(start: number, stop: number, step?: number) {
    const rangeStep = step ?? 1
    return Array.from({ length: (stop - start) / rangeStep + 1 }, (_, index) => start + index * rangeStep)
}

export function AddOrRemove(array: Array<string>, value: string) {
    return array.includes(value) ? array.filter((item) => item !== value) : [...array, value]
}
